import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { withRouter, RouteComponentProps } from "react-router-dom";
import PmoTooltip from "../../../ProductMarketingOptimization/components/common/PmoTooltip";
import BrandPerformanceTable from "../../../../components/Tables/BrandPerformanceTable";
import LoadingEllipsis from "../../../../components/Loading/LoadingEllipsis";
import { NoDataMsg } from "../../../../components/AppMessages";

import { getRVTableForDownloadData } from "../../../../api/brandPerformanceApi";
import { RootStateOrAny, useSelector } from "react-redux";
import CompetitorSelect from "../competitorSelect";

interface Props extends RouteComponentProps {
  diff: number;
  onHandleRadioClick: any;
  nissanCompetitor: string;
  granularity: string;
}

const TableForDownloadRV = withRouter((props: Props) => {
  const { history, onHandleRadioClick, nissanCompetitor, granularity } = props;
  const params = useSelector((state: RootStateOrAny) => state.parameters);

  const {
    data: rvTableForDownloadData,
    isFetching: loadingRVTableForDownloadData,
    refetch: refetchTableForDownloadRV,
  } = useQuery(["rvTableForDownloadData", granularity, history.location.search], () => getRVTableForDownloadData(params), {
    enabled: false,
  });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchTableForDownloadRV();
  }, [history.location.search]);

  // the backend response returns a dynamic date columns with the format of "yyyy-mm-dd" this helps to filter out the date columns
  const dateKeys =
    rvTableForDownloadData?.length > 0 ? Object.keys(rvTableForDownloadData[0]).filter((key) => key.match(/^\d{4}-\d{2}-\d{2}$/)) : [];

  // Define dynamic date columns
  const dynamicColumns = dateKeys.map((dateKey) => ({
    id: dateKey,
    Header: dateKey,
    accessor: dateKey,
    Cell: (props: { value: number }) => {
      const { value } = props;
      // number is in thousands add commas
      const formattedValue = `${value?.toLocaleString()}%`;
      return formattedValue;
    },
  }));

  const staticColumns = [
    {
      id: "no",
      Header: `No`,
      accessor: "no",

      Cell: (props: { value: string }) => {
        const { value } = props;

        return value;
      },
    },
    {
      Header: "Country",
      accessor: `market`,
      id: "market",

      Cell: ({ value }: { value: number }) => {
        return value;
      },
    },
    {
      Header: "Nissan Competitor Set",
      accessor: `nissan_competitor_set`,
      id: "nissan_competitor_set",

      Cell: ({ value }: { value: number }) => {
        return value;
      },
    },
    {
      Header: "Brand",
      accessor: `brand`,
      id: "brand`,",

      Cell: ({ value }: { value: number }) => {
        return value;
      },
    },
    {
      Header: "Model",
      accessor: `model`,
      id: "model`,",

      Cell: ({ value }: { value: number }) => {
        return value;
      },
    },
    {
      Header: "‘Annual Mileage / KM",
      accessor: `annual_mileage`,
      id: "annual_mileage`,",

      Cell: ({ value }: { value: number }) => {
        return value;
      },
    },
    {
      Header: "MO",
      accessor: `forecast_month`,
      id: "forecast_month`,",

      Cell: ({ value }: { value: number }) => {
        return value;
      },
    },
    {
      Header: "Model Year",
      accessor: `model_year`,
      id: "model_year`,",

      Cell: ({ value }: { value: number }) => {
        return value;
      },
    },
  ];

  const columns = React.useMemo(() => [...staticColumns, ...dynamicColumns], [staticColumns, dynamicColumns]);

  return (
    <div className="table-download-content">
      <div className="primary_background ">
        <div className="header" style={{ padding: "1.5em" }}>
          <div className="title_container">
            <h3>Table for data Download (RV)</h3>
            <CompetitorSelect onHandleRadioClick={onHandleRadioClick} nissanCompetitor={nissanCompetitor} />
          </div>
        </div>
        <div className="table_wrapper">
          <div className="chart_content brand_perf_table" style={{ margin: "1em" }}>
            {rvTableForDownloadData?.length && !loadingRVTableForDownloadData ? (
              <BrandPerformanceTable
                isLoading={loadingRVTableForDownloadData}
                columns={columns ?? []}
                tableId="tableForDownloadMonthlyID"
                data={rvTableForDownloadData ?? []}
                initialSortCol={{ id: "No", desc: false }}
              />
            ) : loadingRVTableForDownloadData ? (
              <LoadingEllipsis isLoading={loadingRVTableForDownloadData} />
            ) : (
              <NoDataMsg message="No data available" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
export default TableForDownloadRV;
